import { combineReducers } from 'redux';
import notesStore from './notesDetails';

export default combineReducers({
  notesStore,
});
